// extracted by mini-css-extract-plugin
export default {"container":"invoices_container__3cJJi","content":"invoices_content__yPo4p"};